import { InvestigacionDTO } from "@DTOS";
import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { Actualizador } from "./Actualizador";
import { AccionEnum } from "@shared/enums";

export class CuestionarioActualizador extends Actualizador {
    constructor() {
        super();
    }

    public async actualizar(
        investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion
    ): Promise<InvestigacionDTO> {
        const investigacionClon = investigacion.clon();
        if (datos.datosEncuesta!.accion === AccionEnum.AGREGAR) {
            investigacionClon.encuestas.push(datos.datosEncuesta!.encuesta);
        } else if (datos.datosEncuesta!.accion === AccionEnum.BORRAR) {
            investigacionClon.encuestas = investigacionClon.encuestas
                .filter(x => x.id !== datos.datosEncuesta!.encuesta.id);
        }
        return investigacionClon;
    }

    public esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return datos.datosEncuesta != null;
    }

}
